import app from 'flarum/app';
import Button from 'flarum/components/Button';
import LinkButton from 'flarum/components/LinkButton';
import Placeholder from 'flarum/components/Placeholder';
import listItems from 'flarum/helpers/listItems';
import avatar from 'flarum/helpers/avatar';
import username from 'flarum/helpers/username';
import AbstractFormPage from './AbstractFormPage';
import PageContainer from '../components/PageContainer';
import LoadingIndicator from '../components/LoadingIndicator';
import SubmissionListState from '../states/SubmissionListState';
import SubmissionSortDropdown from '../components/SubmissionSortDropdown';
import ExportModal from '../modals/ExportModal';
import FormEditHeader from '../components/FormEditHeader';

/* global m */

const translationPrefix = 'kilowhat-formulaire.forum.submission-index.';

export default class SubmissionIndexPage extends AbstractFormPage {
    init() {
        super.init();

        this.submissionList = new SubmissionListState({
            q: 'form:' + m.route.param('id'),
        });
        this.submissionList.refresh();
    }

    content() {
        return PageContainer.component({}, [
            FormEditHeader.component({
                form: this.form,
                changeTab: key => {
                    app.cache.formulaireFormEditTab = key;
                    m.route(app.route.formulaireFormEdit(this.form));
                },
                isSubmissionPage: true,
            }),
            m('.FormulaireFilters', [
                m(SubmissionSortDropdown, {
                    sort: this.submissionList.params.sort,
                    onchange: value => {
                        this.submissionList.params.sort = value;
                        this.submissionList.refresh();
                    },
                }),
                this.form.type() === 'standalone' ? LinkButton.component({
                    className: 'Button',
                    href: app.route.formulaireFormShow(this.form),
                }, app.translator.trans(translationPrefix + 'form-show')) : null,
                //TODO: clear all, filters
                this.form.attribute('canExport') ? Button.component({
                    className: 'Button Button--primary',
                    onclick: () => {
                        app.modal.show(new ExportModal({
                            form: this.form,
                        }));
                    },
                    icon: 'fas fa-file-export',
                }, app.translator.trans(translationPrefix + 'export')) : null,
            ]),
            this.list(this.submissionList),
        ]);
    }

    list(state) {
        let loading;

        if (state.loading) {
            loading = LoadingIndicator.component();
        } else if (state.moreResults) {
            loading = Button.component({
                className: 'Button',
                onclick: state.loadMore.bind(state),
            }, app.translator.trans(translationPrefix + 'load-more'));
        }

        if (state.submissions.length === 0 && !state.loading) {
            return Placeholder.component({
                text: app.translator.trans(translationPrefix + 'empty'),
            });
        }

        return m('div', [
            m('table.FormulaireDataTable', [
                m('thead', m('tr', [
                    m('th', app.translator.trans(translationPrefix + 'columns.date')),
                    m('th', app.translator.trans(translationPrefix + 'columns.user')),
                    m('th', app.translator.trans(translationPrefix + 'columns.actions')),
                ])),
                m('tbody', state.submissions.map(submission => {
                    const user = submission.user();
                    const badges = submission.badges().toArray();

                    return m('tr', [
                        m('td', [
                            submission.createdAt(),
                            badges.length ? m('ul.FormulaireDataTable-badges.badges', listItems(badges)) : null,
                        ]),
                        m('td', user ? [
                            avatar(user),
                            username(user),
                        ] : app.translator.trans(translationPrefix + 'guest')),
                        m('td', [
                            LinkButton.component({
                                className: 'Button',
                                href: app.route.formulaireSubmission(submission),
                            }, app.translator.trans(translationPrefix + 'show')),
                        ]),
                    ]);
                })),
            ]),
            loading,
        ]);
    }
}
